import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PromotionLayer from "../../components/PromotionPayment/PromotionPaymentLayer";


const PromiotionPaymentList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Promotion Payment" />

        {/* UsersListLayer */}
        <PromotionLayer />

      </MasterLayout>

    </>
  );
};

export default PromiotionPaymentList; 
